export const defaultConfig = {
    //Localhost API URL
    // baseAPIUrl: "https://laravel9.etrueconcept.com/football_pathway/api/",
    //  baseAPIUrl:"http://192.168.0.170:5300/api/v1/",
    // baseAPIUrl: "http://192.168.0.70:5200/api/v1/",
    // baseAPIUrl: "http://192.168.0.70:5200/api/v1/",
    // imageUrl: "http://192.168.0.170:5300/images/"
     baseAPIUrl:"https://komutanapi.etrueconcept.com/api/v1/",
     imageUrl:"https://komutanapi.etrueconcept.com/images/"

};

export const configUrl = {
  // webSocketUrl: "http://192.168.0.170:5300/",
  // webSocketUrl: "https://unloved-cubicle-actress.ngrok-free.dev/",
  webSocketUrl: "https://komutanapi.etrueconcept.com/", 
};  